import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLazyDownloadLogQuery, } from '~/api/logs/LoggingService.api';
import download from 'downloadjs';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

interface LogFilesDownloadButtonProps {
    contentId: string;
    fileKey: string;
}

const LogFilesDownloadButton: React.FC<LogFilesDownloadButtonProps> = ({ contentId, fileKey }) => {
    const [downloadLog] = useLazyDownloadLogQuery<any>();
    const fileFullName = useMemo(() => fileKey?.split('/').pop() || `log_${contentId}`, [fileKey, contentId]);
    const displayName = useMemo(() => {
        if (fileFullName.length <= 30) return fileFullName;
        return `${fileFullName.slice(0, 12)}...${fileFullName.slice(-12)}`;
    }, [fileFullName]);
    const handleOnClick = async() => {
        await downloadLog(contentId).unwrap().then(async(result) => {
            const response = await fetch(result, {
                method: 'GET',
                headers: {
                    Accept: 'application/octet-stream',
                    'Content-Type': 'application/octet-stream',
                },
            });
            response.blob().then(data => download(data, fileFullName, 'application/octet-stream'));

        });
    };

    return (<div className='btn-toolbar pull-right'>
        <div className='btn-group'>
            <FormattedMessage id='intl-msg:download'>
                {title =>
                    <button className='btn btn-link'
                            title={title}
                            data-key={contentId}
                            onClick={handleOnClick}>
                        <OverlayTrigger placement='top' overlay={<Tooltip id={`tooltip-${contentId}`}>{fileFullName}</Tooltip>}>
                            <span className='text-decoration-underline'>{displayName}</span>
                        </OverlayTrigger>
                        <span className='uikit-icon icon-download' aria-hidden='true'></span>
                    </button>
                }
            </FormattedMessage>
        </div>
    </div>);

};

export default LogFilesDownloadButton;
